export default {
  transaction: {
    title: 'Transaksi',
    select: 'Pilih',
    all: 'Semua',
    loading: 'Memuat...',
    noMoreData: 'Tidak ada data lagi',
    mockSuccess: 'Simulasi Berhasil',
    mockFail: 'Simulasi Gagal',
    mockSuccessDone: 'Simulasi berhasil selesai',
    mockFailDone: 'Simulasi gagal selesai',
    mockFailed: 'Simulasi gagal',
    today: 'Hari ini',
    yesterday: 'Kemarin',
    last3Days: '3 hari terakhir',
    last7Days: '7 hari terakhir',
    last15Days: '15 hari terakhir',
    last30Days: '30 hari terakhir',
    allTypes: 'Semua jenis',
    deposit: 'Deposit',
    withdrawal: 'Penarikan',
    withdrawalRefund: 'Pengembalian penarikan',
    bet: 'Taruhan',
    win: 'Menang',
    manualAdd: 'Tambah manual',
    manualSubtract: 'Kurangi manual',
    commission: 'Komisi',
    bonus: 'Bonus',
    vipUpgradeReward: 'Hadiah upgrade VIP',
    vipSalary: 'Gaji VIP',
    gameOutPrincipal: 'Keluar game - Pokok',
    gameOutBonus: 'Keluar game - Bonus',
    bonusTransferOut: 'Transfer bonus keluar',
    allStats: 'Semua status',
    underReview: 'Dalam peninjauan',
    pendingPayout: 'Menunggu pembayaran',
    successful: 'Berhasil',
    failed: 'Gagal',
    cancelled: 'Dibatalkan',
    processing: 'Memproses',
  },
};
